document.addEventListener("DOMContentLoaded", () => {
  const mainWrapper = document.querySelector(".td-wishlist");
  const modal = document.querySelector(".td-wishlist__modal");

  const templates = {
    emptyState: mainWrapper.querySelector("[data-wishlist-template='empty']"),
    lists: mainWrapper.querySelector("[data-wishlist-template='list']"),
    listCard: mainWrapper.querySelector("[data-wishlist-template='list-card']"),
    productsList: mainWrapper.querySelector(
      "[data-wishlist-template='products-list']"
    ),
    productCard: mainWrapper.querySelector(
      "[data-wishlist-template='product-card']"
    ),
    shareModal: mainWrapper.querySelector(
      "[data-wishlist-template='share-list-modal']"
    ),
  };

  const modalElements = {
    title: modal.querySelector(".td-wishlist-modal__title"),
    content: modal.querySelector(".td-wishlist-modal__content"),
    buttons: modal.querySelector(".td-wishlist-modal__buttons"),
  };

  let currentListProducts = [];
  let productsGrid = [];
  let productsData = [];

  function initWishlist() {
    mainWrapper.classList.add("loading");
    window._swat.fetchLists({
      callbackFn: handleLists,
      errorFn: onError,
    });
  }

  const initSharedList = (swat) => {
    const queryParams = swat.utils.getEncodedAsObject(window.location.search);
    const sharedHkey = queryParams["hkey"] || queryParams["lid"];
    if (sharedHkey) {
      const sharedWishlistContainerElement = document.querySelector(
        "#swym-shared-wishlist-render-container"
      );
      swat.ui.renderSharedWishlistInContainer(
        sharedWishlistContainerElement,
        sharedHkey,
        queryParams
      );
    }
  };

  function handleLists(lists) {
    if (!lists.length) {
      renderEmptyState();
      return;
    }
    renderLists(lists);
  }

  function renderLists(lists) {
    const listsWrapper = templates.lists.content
      .querySelector(".td-wishlist__list-wrapper")
      .cloneNode(true);
    const listsGrid = listsWrapper.querySelector(".td-wishlist__list-grid");

    lists.forEach((list) => {
      const card = getListCard(list);
      listsGrid.append(card);
    });
    mainWrapper.classList.remove("loading");
    templates.lists.after(listsWrapper);
  }

  function getListCard(list) {
    const card = templates.listCard.content.firstElementChild.cloneNode(true);
    const cardTitle = card.querySelector(".td-wishlist-lists__list-title");
    const cardCount = card.querySelector(".td-wishlist-lists__list-count");
    const imageContainer = card.querySelector(
      ".td-wishlist-lists__list-image-container"
    );

    cardTitle.textContent = list.lname;
    cardCount.textContent = `${list.cnt} product${list.cnt > 1 ? "s" : ""}`;

    if (list.cnt > 0) {
      let imagesMarkup = "";
      const latestItems = list.listcontents.slice(0, 3);
      latestItems.forEach((item, i) => {
        imagesMarkup += `<div><img class="" src="${item.iu}"></div>`;
      });
      imageContainer.innerHTML = imagesMarkup;
    } else {
      card.classList.add("td-wishlist-lists__list--empty");
      imageContainer.innerHTML = "<span>THIS IS AN EMPTY LIST!</span>";
    }
    card.addEventListener("click", (e) => {
      renderListItems(list);
    });
    return card;
  }

  function renderListItems(list) {
    const productsView =
      templates.productsList.content.firstElementChild.cloneNode(true);
    const image = productsView.querySelector(".td-wishlist-products__image");
    const select = productsView.querySelector(".td-wishlist-select__input");
    productsGrid = productsView.querySelector(".td-wishlist-products");
    productsGrid.classList.remove("td-wishlist-products-loaded");

    const currentItem = productsView.querySelector(
      ".td-wishlist-select__current-item"
    );
    const currentItemTitle = currentItem.querySelector(
      ".td-wishlist-select__current-item-title"
    );
    const currentItemImage = currentItem.querySelector(
      ".td-wishlist-select__image"
    );
    const currentItemCount = currentItem.querySelector(
      ".td-wishlist-select__current-item-count"
    );

    const toggle = productsView.querySelector(".td-wishlist-select__toggle");
    const toggleTitle = toggle.querySelector(
      ".td-wishlist-select__toggle-title"
    );
    const itemsWrapper = productsView.querySelector(
      ".td-wishlist-select__list-items"
    );

    const shareListButton = productsView.querySelector(
      ".td-wishlist-share-list"
    );
    const duplicateListButton = productsView.querySelector(
      ".td-wishlist-list__action-duplicate"
    );
    const deleteListButton = productsView.querySelector(
      ".td-wishlist-list__action-delete"
    );
    const back = productsView.querySelector(".td-wishlist-products__back");
    const listsWrapper = document.querySelector(".td-wishlist__list-wrapper");

    const getInitials = (name) => {
      return name
        .match(/(\b\w)/gi)
        .slice(0, 2)
        .join("")
        .toUpperCase();
    };

    const generateListItem = (listDef) => {
      const item = document.createElement("label");
      item.className = "td-wishlist-select__item";
      const img =
        listDef.cnt > 0
          ? `<img class="td-wishlist-products__image" src="${listDef.listcontents[0].iu}" alt="">`
          : "";
      item.innerHTML = `
              <figure>
                ${img}
                <span>${getInitials(listDef.lname)}</span>
              </figure>
              <div class="td-wishlist-select__item-details">
                <h3 class="td-wishlist-select__item-title text-base">${
                  listDef.lname
                }</h3>
                <span class="td-wishlist-select__item-count">${
                  listDef.cnt
                } product${listDef.cnt > 0 ? "s" : ""}</span>
                  <input hidden type="radio" name="wishlist" value="${
                    listDef.lid
                  }" data-image="${
        listDef.cnt > 0 ? listDef.listcontents[0].iu : ""
      }">
              </div>
              `;
      return item;
    };

    const setThumbImage = (imageEl, src) => {
      imageEl.src = src;
      imageEl.classList.remove("hidden");
    };

    const setThumbInitials = (imageEl, initials) => {
      imageEl.classList.add("hidden");
      const thumbWrapper = imageEl.parentElement;
      const initialsEl =
        thumbWrapper.querySelector(".wishlist-initials") ||
        document.createElement("span");
      initialsEl.classList.add("wishlist-initials");
      initialsEl.textContent = initials;
      thumbWrapper.append(initialsEl);
    };

    if (list.cnt > 0) {
      setThumbImage(image, list.listcontents[0].iu);
      setThumbImage(currentItemImage, list.listcontents[0].iu);
    } else {
      const initials = getInitials(list.lname);
      setThumbInitials(image, initials);
      setThumbInitials(currentItemImage, initials);
    }

    currentItem.dataset.selectedId = list.lid;
    toggleTitle.textContent = list.lname;
    currentItemTitle.textContent = list.lname;
    currentItemCount.textContent = `${list.cnt} product${
      list.cnt > 0 ? "s" : ""
    }`;
    if (shareListButton) shareListButton.disabled = list.cnt === 0;

    window._swat.fetchLists({
      callbackFn: function (lists) {
        lists.forEach((listDef) => {
          const option = document.createElement("option");
          option.value = listDef.lid;
          option.textContent = listDef.lname;

          if (listDef.cnt > 0)
            option.dataset.image = listDef.listcontents[0].iu;
          if (listDef.lid == list.lid) option.selected = true;

          select.append(option);
          const item = generateListItem(listDef);
          itemsWrapper.append(item);
        });

        itemsWrapper
          .querySelectorAll('input[name="wishlist"]')
          .forEach((input) => {
            input.addEventListener("change", (e) => {
              if (!input.checked) return;
              productsGrid.classList.remove("td-wishlist-products-loaded");
              const item = input.closest(".td-wishlist-select__item");
              const itemTitle = item.querySelector(
                ".td-wishlist-select__item-title"
              );
              const itemCount = item.querySelector(
                ".td-wishlist-select__item-count"
              );
              const listCount = parseInt(itemCount.textContent);
              productsGrid.innerHTML = "";

              currentItem.dataset.selectedId = input.value;
              currentItemTitle.textContent = itemTitle.textContent;
              currentItemCount.textContent = itemCount.textContent;
              toggleTitle.textContent = itemTitle.textContent;
              if (shareListButton) shareListButton.disabled = listCount === 0;

              if (listCount > 0) {
                setThumbImage(image, input.dataset.image);
                setThumbImage(currentItemImage, input.dataset.image);
              } else {
                const initials = getInitials(itemTitle.textContent);
                setThumbInitials(image, initials);
                setThumbInitials(currentItemImage, initials);
              }

              renderProductsGrid(input.value);
            });
          });

        back.addEventListener("click", () => {
          productsView.remove();
          renderLists(lists);
        });
      },
      errorFn: onError,
    });

    select.addEventListener("change", () => {
      productsGrid.classList.remove("td-wishlist-products-loaded");
      productsGrid.innerHTML = "";
      image.src = select.options[select.selectedIndex].dataset.image || "";
      renderProductsGrid(select.value);
    });

    if (shareListButton) {
      shareListButton.addEventListener("click", () => {
        const listId = currentItem.dataset.selectedId;
        openShareModal(listId);
      });
    }

    duplicateListButton.addEventListener("click", () => {
      const fromlid = currentItem.dataset.selectedId;
      openNewListModal(fromlid);
    });

    deleteListButton.addEventListener("click", () => {
      const listId = currentItem.dataset.selectedId;
      const listName = currentItemTitle.textContent;
      openDeleteListModal(listId, listName);
    });

    if (listsWrapper) listsWrapper.remove();
    templates.productCard.after(productsView);

    const sortSelector = document.getElementById("listWishlistSort");
    sortSelector?.addEventListener("change", function () {
      document
        .querySelector(".td-wishlist-products-loaded")
        ?.classList.remove("td-wishlist-products-loaded");
      const optionSelected = this.value;
      const filteredList = sortItems(currentListProducts, optionSelected);
      renderListContents(filteredList);
    });
    renderProductsGrid(list.lid);
  }

  const renderProductsGrid = (lid) => {
    _swat.fetchListCtx(
      { lid: lid },
      (listContents) => {
        currentListProducts = listContents;
        const emptyView = document.querySelector(".empty-wishlist-view");
        if (listContents.length) {
          productsGrid.classList.remove("hidden");
          renderListContents(listContents);
          if (emptyView) emptyView.remove();
        } else {
          const emptyState = emptyView || getEmptyState();
          productsGrid.classList.add("hidden");
          productsGrid.after(emptyState);
        }
      },
      function (xhrObj) {
        console.log("Failed to fetch list items");
      }
    );
  };

  const renderProductCard = (listItem) => {
    _swat.getProductDetails(
      listItem,
      function (productJson) {
        const addedProduct = productsData.find((p) => p.id == productJson.id);
        addedProduct || productsData.push(productJson);
        const productCard = getProductCard(productJson, listItem);
        productsGrid.append(productCard);
      },
      function (e) {
        console.log(e);
      }
    );
  };

  const renderListContents = (listContents) => {
    productsGrid.innerHTML = "";
    listContents.forEach((listItem) => {
      renderProductCard(listItem);
    });
    productsGrid.classList.add("td-wishlist-products-loaded");
  };

  const sortItems = (items, sortOption) => {
    return items.sort((a, b) => {
      if (sortOption === "a-z") {
        return a.dt.localeCompare(b.dt);
      }
      if (sortOption === "z-a") {
        return b.dt.localeCompare(a.dt);
      }
      if (sortOption === "price-low-high") {
        return a.pr - b.pr;
      }
      if (sortOption === "price-high-low") {
        return b.pr - a.pr;
      }
      if (sortOption === "last-added") {
        return b.cts - a.cts;
      }
    });
  };

  function getProductCard(product, listItem) {
    const card =
      templates.productCard.content.firstElementChild.cloneNode(true);
    const removeButton = card.querySelector(
      ".td-wishlist-products__remove-product"
    );
    const image = card.querySelector(".td-wishlist-products__product-image");
    const title = card.querySelector(".td-wishlist-products__product-title");
    const desc = card.querySelector(".td-wishlist-products__product-desc");
    const price = card.querySelector(".td-wishlist-products__product-price");
    const buttons = card.querySelector(".td-wishlist-products__buttons");
    let variant = product.variants.find(
      (variant) => variant.id === listItem.epi
    );

    if (!variant) {
      let shape = listItem.vi && listItem.vi.match(/(round|square)/gi);
      variant = shape
        ? product.variants.find((variant) =>
            variant.title.toLowerCase().includes(shape[0].toLowerCase())
          )
        : product.variants[0];
    }

    const currencySymbol = Shopify.currency.active;

    const moneyFormat = `${currencySymbol}{{amount}}`;

    card.href = `${Shopify.routes.root}products/${product.handle}?variant=${variant.id}`;

    removeButton.addEventListener("click", (e) => {
      e.preventDefault();
      const listItemMap = {
        epi: listItem.epi,
        empi: listItem.empi,
        du: listItem.du,
      };
      const listId = listItem.lid;

      window._swat.deleteFromList(
        listId,
        listItemMap,
        function (deletedListItem) {
          card.remove();
        },
        function (xhrObj) {
          console.log("Failed to remove product from list");
        }
      );
    });

    image.src = listItem.iu + "&width=150";
    title.textContent = product.title;
    desc.textContent = variant.public_title;

    if (variant.available) {
      if (variant.compare_at_price > variant.price)
        price.innerHTML = `
          <del class="text-black">${theme.Currency.formatMoney(
            variant.compare_at_price,
            moneyFormat
          )}</del>
          <span class="text-[#D91945]">${theme.Currency.formatMoney(
            variant.price,
            moneyFormat
          )}</span>
      `;
      else
        price.innerHTML = `<span class="text-black">${theme.Currency.formatMoney(
          variant.price,
          moneyFormat
        )}</span>`;

      buttons.innerHTML = `
              <form action="/cart/add" method="post">
                  <input type="hidden" name="id" value="${variant.id}" />
                  <input type="hidden" name="quantity" value="1" />
                  <button type="submit" class="btn">
                      <div class="animate-spin w-4 h-4 animate-none hidden">
                          <svg role="none" class="text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                          </svg>
                      </div>
                      <span>Add to Cart</span>
                  </button>
              </form>
          `;
    } else {
      price.innerHTML = "";
      buttons.innerHTML = `
              <a href="${product.url}" class="">
                  View product
              </a>`;
    }
    return card;
  }

  modal.addEventListener("click", (event) => {
    const target = event.target;
    if (target.classList.contains("td-wishlist-modal__js-close")) {
      modal.hide();
    }
  });

  function openNewListModal(fromlid) {
    modalElements.title.textContent = "Duplicate List";
    modalElements.content.innerHTML =
      '<input type="text" minlength="3" maxlength="50" placeholder="Wishlist name">';
    modalElements.buttons.innerHTML = `
          <button class="td-wishlist-modal__js-close">CANCEL</button>
          <button disabled class="td-wishlist-modal__js-create btn">CREATE NEW LIST</button>
      `;
      
    const listNames = [];
    const input = modalElements.content.querySelector("input");
    const createButton = modalElements.buttons.querySelector(
      ".td-wishlist-modal__js-create"
    );

    const validateName = (name) => {
      if (name.length < 3 || name.length > 50 || listNames.includes(name)) {
        createButton.disabled = true;
      } else {
        createButton.disabled = false;
      }
    };

    _swat.fetchLists({
      callbackFn: (lists) => {
        lists.forEach((list) => {
          listNames.push(list.lname);
          if (fromlid && list.lid == fromlid)
            input.placeholder = "My Wishlist Copy";
        });
      },
      errorFn: (xhr) => {},
    });

    input.addEventListener("input", (e) => {
      validateName(e.target.value);
    });

    createButton.addEventListener("click", () => {
      const newListDef = {
        lname: input.value,
      };

      if (fromlid) newListDef.fromlid = fromlid;

      _swat.createList(
        newListDef,
        function () {
          _swat.fetchLists({
            callbackFn: function (lists) {
              const listsWrapper = document.querySelector(
                ".td-wishlist__list-wrapper"
              );
              const productsView = document.querySelector(
                ".td-wishlist-products-view"
              );
              const emptyView = document.querySelector(".td-wishlist__empty");

              if (listsWrapper) listsWrapper.remove();
              if (productsView) productsView.remove();
              if (emptyView) emptyView.remove();
              modal.hide();

              renderLists(lists);
            },
          });
        },
        function (xhrObject) {
          console.log("Failed to create new list");
        }
      );
    });
    modal.show();
  }

  function openDeleteListModal(listId, listName) {
    modalElements.title.textContent = "Are You Sure?";
    modalElements.content.innerHTML = `Are you sure you would like to delete <span class="td-wishlist-list-name">${listName}</span>?`;
    modalElements.buttons.innerHTML = `
          <button class="td-wishlist-modal__js-close">CANCEL</button>
          <button class="td-wishlist-modal__js-delete btn">DELETE LIST</button>
      `;

    modalElements.buttons
      .querySelector(".td-wishlist-modal__js-delete")
      .addEventListener("click", () => {
        _swat.deleteList(
          listId,
          function (deletedListObj) {
            _swat.fetchLists({
              callbackFn: function (lists) {
                const listsWrapper = document.querySelector(
                  ".td-wishlist__list-wrapper"
                );
                const productsView = document.querySelector(
                  ".td-wishlist-products-view"
                );
                const emptyView = document.querySelector(
                  ".td-wishlist__empty-wrapper"
                );

                if (listsWrapper) listsWrapper.remove();
                if (productsView) productsView.remove();
                if (emptyView) emptyView.remove();
                lists.length > 0 ? renderLists(lists) : renderEmptyState();
                modal.hide();
              },
            });
          },
          function (xhrObject) {
            console.log("Failed to delete list");
          }
        );
      });
    modal.show();
  }

  function openShareModal(listId) {
    modalElements.title.textContent = "Share List Via Email";
    modalElements.content.innerHTML = "";
    modalElements.content.append(
      templates.shareModal.content.firstElementChild.cloneNode(true)
    );
    modalElements.buttons.innerHTML = `
        <button class="td-wishlist-modal__js-close">CANCEL</button>
        <button disabled class="td-wishlist-modal__js-share btn"><span>SHARE LIST</span><span>SHARED!</span></button>
      `;
    const email = modalElements.content.querySelector(
      "#td-wishlist-modal__email"
    );
    const shareButton = modalElements.buttons.querySelector(
      ".td-wishlist-modal__js-share"
    );
    email.addEventListener("input", function (e) {
      const email = e.currentTarget.value;
      shareButton.classList.remove("td-wishlist-modal__js-share--success");
      const emailPattern =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (emailPattern.test(String(email).toLowerCase())) {
        shareButton.disabled = false;
      } else {
        shareButton.disabled = true;
      }
    });

    shareButton.addEventListener("click", () => {
      window._swat.api.sendListViaEmail(
        {
          toEmailId: modalElements.content.querySelector(
            "#td-wishlist-modal__email"
          ).value,
          fromName: modalElements.content.querySelector(
            "#td-wishlist-modal__name"
          ).value,
          note: modalElements.content.querySelector("#td-wishlist-modal__note")
            .value,
          lid: listId,
        },
        function (e) {
          shareButton.classList.add("td-wishlist-modal__js-share--success");
        },
        function (e) {
          console.log("Failed to send email");
        }
      );
    });
    modal.show();
  }

  function renderEmptyState() {
    const emptyStateSection = getEmptyState();
    mainWrapper.classList.remove("loading");
    templates.emptyState.after(emptyStateSection);
  }

  function getEmptyState() {
    const emptyStateSection =
      templates.emptyState.content.firstElementChild.cloneNode(true);
    return emptyStateSection;
  }

  function onError(error) {
    console.log("Error", error);
  }

  const setupCurrency = () => {
    if (SwymUtils._ajaxGET) return;
    SwymUtils._ajaxGET = SwymUtils.ajaxGET;
    SwymUtils.ajaxGET = function (url, callback, context) {
      let currencyUrl = new URL(url);
      currencyUrl.searchParams.set("currency", Shopify.currency.active);
      currencyUrl.searchParams.set("country", Shopify.country);
      return SwymUtils._ajaxGET(currencyUrl.href, callback, context);
    };
  };

  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }

  const isSharedList = new URLSearchParams(location.search).has("hkey");

  if (isSharedList) {
    window.SwymCallbacks.push(initSharedList);
    return;
  } else {
    window.SwymCallbacks.push(setupCurrency);
    window.SwymCallbacks.push(initWishlist);
  }
});
